import isEmpty from "lodash-es/isEmpty";
import { useRouter } from "next/router";
import { useMemo } from "react";

import { isRunningInIframe, parseIframeUrlPath } from "@moment/ui";

export const useRouteParams = () => {
	const router = useRouter();

	return useMemo(() => {
		const workspaceName = router.query["workspaceName"];
		const documentId = router.query["documentId"];
		const pageSlug = router.query["pageSlug"];
		const path = router.asPath;

		if (isRunningInIframe()) {
			const params = parseIframeUrlPath(window.location.href);
			return {
				workspaceName: isEmpty(workspaceName) ? params.workspaceName : `${workspaceName}`,
				documentId: isEmpty(documentId) ? params.documentId : `${documentId}`,
				pageSlug: isEmpty(pageSlug) ? params.pageId : `${pageSlug}`,
				path,
			};
		}

		return {
			workspaceName: isEmpty(workspaceName) ? "" : `${workspaceName}`,
			documentId: isEmpty(documentId) ? "" : `${documentId}`,
			pageSlug: isEmpty(pageSlug) ? "" : `${pageSlug}`,
			path,
		};
	}, [router.asPath, router.query]);
};
